import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ShieldCheck, ShieldAlert, ShieldQuestion } from "lucide-react";
import { cn } from "@/lib/utils";

export function confidenceLevel(value) {
  if (value === null || value === undefined) return null;
  if (value >= 0.85) return "high";
  if (value >= 0.6) return "medium";
  return "low";
}

const COPY = {
  high: { label: "Høy sikkerhet", icon: ShieldCheck, help: "Feltet ble lest med høy sikkerhet." },
  medium: { label: "Middels sikkerhet", icon: ShieldQuestion, help: "Feltet bør kontrolleres mot dokumentet." },
  low: { label: "Lav sikkerhet – kontroller", icon: ShieldAlert, help: "Vi var usikre. Sjekk feltet nøye før du bekrefter." },
};

export const ConfidencePill = ({ value, className }) => {
  const level = confidenceLevel(value);
  if (!level) return null;
  const cfg = COPY[level];
  const Icon = cfg.icon;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn("inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium", `conf-${level}`, className)} data-testid={`confidence-${level}`}>
          <Icon className="h-3 w-3" />
          {Math.round(value * 100)} %
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p className="font-medium">{cfg.label}</p>
        <p className="text-xs text-muted-foreground">{cfg.help}</p>
      </TooltipContent>
    </Tooltip>
  );
};
